'use strict';

import moment from 'moment' ;

function DebtColorDirective() {
    return {
        restrict: 'A',
        scope: {
            debtValue: '<'
        },
        link: function(scope, element, attrs, controller) {
            if (scope.debtValue && scope.debtValue > 0) {
                element.addClass('deleted-color');
            }
        }
    };
}

export default DebtColorDirective;
